module.exports = __webpack_public_path__ + "static/media/javascript.0cded3a3.png";